import { useContext, useEffect } from 'react';
import { useGetDatabaseStructureService } from '../services/useGetDatabaseStructureService';
import GuiContext from 'config/context/guiContext';

const DatabaseStructureFetcher = () => {
    const {
    selected,
  } = useContext(GuiContext);
    const { getDatabaseStructure } = useGetDatabaseStructureService();
    
    useEffect(() => {
        getDatabaseStructure();
    }, [selected]);
    
    return null;
};

export default DatabaseStructureFetcher;
